import styled from 'styled-components';

export const Content = styled.div`
  display: block;
  form {
    display: block;
    width: 415px;
  }
`;
